import { CompanyFeaturesEnum, FeatureSelection } from '@employ-engage/data';
import { useCurrentCompany } from '../contexts';

export const useCompanyFeature = (specificFeatureId: CompanyFeaturesEnum) => {
  const { currentCompany, loading, refetchCompany } = useCurrentCompany();

  return {
    // `?.` on the list too: the context holds `{}` until the company has
    // loaded, and a page asking for a feature must not throw on that first
    // render.
    feature: currentCompany?.featureSelections?.find(
      (feature: FeatureSelection) => {
        return feature.id === specificFeatureId;
      }
    ),
    loading,
    refetch: refetchCompany,
  };
};
